import React from 'react';
import Container from './Container';

export default ({ children, ...rest }) => <Container {...rest}>{children}</Container>;
